import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import TabNav from './TabNav';
import colors from '../../theme/colors';

export default function PageShell() {
  const [lastUpdate, setLastUpdate] = useState(null);

  // Update timestamp whenever child pages poll data — exposed via context
  useEffect(() => {
    const handler = () => setLastUpdate(Date.now());
    window.addEventListener('sv360:data-update', handler);
    return () => window.removeEventListener('sv360:data-update', handler);
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: colors.bg }}>
      <Header lastUpdate={lastUpdate} />
      <TabNav />
      <main style={{ padding: 24, maxWidth: 1400, margin: '0 auto' }}>
        <Outlet />
      </main>
    </div>
  );
}
